/*@ngInject*/
const RestoreRepository = function (baseRepository, temporaryLoginTokenRepository) {

    angular.extend(this, baseRepository);

    this.restore = function (operation, file) {
        var url = '/databaseUpload/databaseUploadServlet',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                params: {
                    operation: operation,
                    mode: 'unmarshal'
                },
                headers: {
                    'Content-Type': undefined
                }
            };
        formData.append('file', file);
        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.post(url, formData, config);
        });
    };

};
angular.module('ums.configuration')
    .service('restoreRepository', RestoreRepository);
